/**
 * @file Automatically generated by barrelsby.
 */

export * from './product-links.resolver';
export * from './resource-links.resolver';
export * from './service-links.resolver';
